
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { StatSection } from './StatSection';

interface HalfTimeStatsCardProps {
  title: string;
  stats: {
    total: { matches: number; winFt: number; drawFt: number; lossFt: number };
    home: { matches: number; winFt: number; drawFt: number; lossFt: number };
    away: { matches: number; winFt: number; drawFt: number; lossFt: number };
  };
  totalMatches: number;
  colorScheme: {
    bgColor: string;
    barColor: string;
  };
}

export const HalfTimeStatsCard: React.FC<HalfTimeStatsCardProps> = ({
  title,
  stats,
  totalMatches,
  colorScheme
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-center">{title}</CardTitle>
      <p className="text-center text-sm text-muted-foreground">
        {stats.total.matches} matches - {((stats.total.matches / totalMatches) * 100).toFixed(1)}% of all matches
      </p>
    </CardHeader>
    <CardContent className="space-y-4">
      <StatSection 
        title="Overall" 
        stats={stats.total} 
        totalMatches={totalMatches}
        colorScheme={colorScheme}
      />
      <Separator className="my-4" />
      <StatSection 
        title="Home" 
        stats={stats.home} 
        totalMatches={totalMatches}
        colorScheme={colorScheme}
      />
      <Separator className="my-4" />
      <StatSection 
        title="Away" 
        stats={stats.away} 
        totalMatches={totalMatches}
        colorScheme={colorScheme}
      />
    </CardContent>
  </Card>
);
